<template>
  <div id="app">
    <component :is="layout">
      <router-view />
    </component>
  </div>
</template>
<script>
import axios from 'axios';
import MainLayout from './layouts/MainLayout';
import AuthLayout from './layouts/AuthLayout';
import EmptyLayout from './layouts/EmptyLayout';
import AdminLayout from './layouts/AdminLayout';
import BaseLayout from './layouts/BaseLayout';

export default {
  data() {
    return {
      appleFaviconSizes: ['57x57', '60x60', '72x72', '76x76', '114x114', '120x120', '144x144', '152x152', '180x180'],
      defaultFaviconSize: ['32x32', '96x96', '16x16']
    }
  },
  computed: {
    layout() {
      return (this.$route.meta.layout || 'main') + '-layout';
    },
  },
  methods: {
    generateFavicons() {
      const head = document.querySelector("head");
      const brandCode = this.$store.getters.brandCode;
      for (const size of this.appleFaviconSizes) {
        const link = document.createElement('link');
        link.sizes = size;
        link.rel = 'apple-touch-icon';
        link.href = `/favicons/${brandCode}/apple-icon-${size}.png`;
        head.appendChild(link);
      }
      for (const size of this.defaultFaviconSize) {
        const link = document.createElement('link');
        link.sizes = size;
        link.rel = 'icon';
        link.type = 'image/png';
        link.href = `/favicons/${brandCode}/favicon-${size}.png`;
        head.appendChild(link);
      }
      const manifestLink = document.createElement('link');
      manifestLink.rel = 'manifest';
      manifestLink.href = `/favicons/${brandCode}/manifest.json`;
      const title = document.createElement('title');
      title.innerText = this.$store.getters.brandTitle;
      head.appendChild(manifestLink);
      head.appendChild(title);
    }
  },
  beforeMount() {
    this.generateFavicons();
  },
  created() {
    axios.interceptors.response.use(
      function (response) {
        return response;
      },
      (error) => {
        if (
          401 === error.response.status ||
          error.response.data === 'Invalid Token'
        ) {
          this.$store.dispatch('logout');
          this.$router.push('/login');
        } else {
          return Promise.reject(error);
        }
      }
    );
  },
  components: {
    MainLayout,
    AuthLayout,
    EmptyLayout,
    AdminLayout,
    BaseLayout,
  },
};
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  .el-main {
    padding-bottom: 170px;
  }
}
</style>
